import React from "react";
import { NavLink } from "react-router-dom";

const Navigation = ({ sections }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container">
        <NavLink to="/" className="navbar-brand">
          Liternictwo i Kamieniarstwo
        </NavLink>
        {/* <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto">
            {sections.map(section => (
              <li key={section.fields.slug} className="nav-item">
                <NavLink to={`/${section.fields.slug}`} className="nav-link">
                  {section.fields.title}
                </NavLink>
              </li>
            ))}
            <li className="nav-item">
              <NavLink to="/kontact" className="nav-link">
                Kontakt
              </NavLink>
            </li>
          </ul>
        </div> */}
      </div>
    </nav>
  );
};

export default Navigation;
